import React from 'react'
import fb from '../../assets/icons/fb.png'
import git from '../../assets/icons/github.png'
import Linkedin from '../../assets/icons/in.png'

const Footer = () => {
    const year = new Date().getFullYear()

    return (
        <footer class="bg-base-200 text-success mt-4">
            <div className="footer max-w-7xl mx-auto lg:p-20 lg:px-10 p-10">
                <div>
                    <h2 class="text-4xl text-warning font-bold tracking-wider">Forhad Uddin</h2>
                    <p>
                        Frontend Developer
                        <br />
                        Meet your need
                    </p>
                </div>
                <div>
                    <span class="footer-title">Social</span>
                    <div class="grid grid-flow-col gap-1">
                        <a href="https://github.com/forhad-eng" target="_blank" rel="noreferrer">
                            <img className="w-10" src={git} alt="" />
                        </a>
                        <a href="https://www.linkedin.com/in/itsforhad2" target="_blank" rel="noreferrer">
                            <img className="w-10" src={Linkedin} alt="" />
                        </a>
                        <a href="https://www.facebook.com/itsforhad2" target="_blank" rel="noreferrer">
                            <img className="w-10" src={fb} alt="" />
                        </a>
                    </div>
                </div>
            </div>
            <div>
                <p className="text-center pb-10">Copyright © {year} - All right reserved by the Developer</p>
            </div>
        </footer>
    )
}

export default Footer
